import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  authenticateUser,
  signupDetails,
  validateOtp,
} from "../services/authenticationServices";

const OtpValidation = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const { phoneNumber, from, email, password, firstName } =
    location.state || {}; // Access the state

  const [errorMessage, setErrorMessage] = useState("");

  const IMG = (imgName) => {
    return `assets/landingpage/images/${imgName}`;
  };

  // Timer logic
  useEffect(() => {
    if (timer > 0 && !canResend) {
      const timerId = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerId);
    } else if (timer === 0) {
      setCanResend(true);
    }
  }, [timer, canResend]);

  // Handle OTP input
  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^[0-9]*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto focus next input
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  // Handle backspace
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  // Resend OTP
  const handleResendOtp = () => {
    if (canResend) {
      setTimer(30);
      setCanResend(false);
      // Add your resend OTP API call here
    }
  };

  // Verify OTP
  const handleVerifyOtp = (e) => {
    e.preventDefault();
    const otpString = otp.join("");
    if (otpString.length === 6) {
      // Add your OTP verification API call here
      navigate("/login"); // Navigate after successful verification
    }
  };

  // Update validation when OTP changes
  useEffect(() => {
    const otpString = otp.join("");
    setIsValid(otpString.length === 6);
  }, [otp]);

  const validateForm = () => {
    const otpString = otp.join("");
    if (!otpString || otpString.length !== 6) {
      setErrorMessage("Please enter a valid 6-digit OTP");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      if (from === "login") {
        await authenticateUser("phone", "", "", phoneNumber, otp.join(""));
        navigate("/dashboard");
      } else {
        await validateOtp(phoneNumber, otp.join(""));
        await signupDetails(email, password, firstName, phoneNumber);
        navigate("/dashboard");
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.detail || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="vh-100">
      <div className="d-flex flex-column flex-md-row h-100">
        {/* Left Panel */}
        <div className="d-flex w-58 max-md-w-100 login-banner-container">
          <Link to="/">
            <img
              loading="lazy"
              src={IMG("logo.svg")}
              alt="Company logo"
              className="z-10 mt-3 ml-0 md-ml-3 w-120 md-w-173 max-md-ml-2 position-absolute top-0 start-0 company-image"
            />
          </Link>
          <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
            <img
              loading="lazy"
              src={IMG("illustration1.svg")}
              alt="Login illustration"
              className="illustration-image"
            />
          </div>
        </div>

        {/* Right Panel */}
        <div className="flex-grow-1 d-flex align-items-center bg-white">
          <main className="login-signup-data d-flex flex-column justify-content-center py-4 h-100 w-100 text-lg font-bold bg-white">
            <div className="text-center">
              <img
                loading="lazy"
                src={IMG("lock.svg")}
                alt="Authentication icon"
                className="img-fluid"
                style={{ width: "99px" }}
              />
              <h1 className="mt-3 text-dark fw-bold fs-1">OTP Verification</h1>
              <p className="text-muted mt-2">
                Enter the OTP sent to {phoneNumber+" "} 
                <span
                   style={{    cursor: "pointer"}}
                  className="text-primary text-decoration-underline cursor-pointer"
                  onClick={() => {
                    if (from === "login") {
                     
                      navigate("/login", { state: { phoneNumber } , replace: true });
                    }
                    if (from === "signup") {
                 
                      navigate("/signup", { state: { phoneNumber ,firstName} , replace: true });
                    }
                  }}
                >
                  Edit
                </span>
              </p>
              {/* <p className="text-muted mt-2" onClick={()=>{
                navigate(-1)
              }}>
                Change Phone number? 
              </p> */}
            </div>

            <form onSubmit={handleVerifyOtp} className="w-100">
              {/* OTP Input Fields */}
              <div className="d-flex justify-content-center gap-2 mt-4">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="number"
                    id={`otp-${index}`}
                    className="form-control text-center"
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    maxLength={1}
                    style={{
                      width: "45px",
                      height: "45px",
                      fontSize: "1.2rem",
                      borderRadius: "8px",
                      borderColor: "#0dcaf0",
                    }}
                  />
                ))}
              </div>

              {/* Timer and Resend */}
              {/* <div className="text-center mt-3">
                {!canResend ? (
                  <p className="text-muted">
                    Resend OTP in {timer} seconds
                  </p>
                ) : (
                  <button
                    type="button"
                    onClick={handleResendOtp}
                    className="btn btn-link text-info text-decoration-none"
                  >
                    Resend OTP
                  </button>
                )}
              </div> */}

              {/* Verify Button */}
              <button
                type="submit"
                className="btn mt-3 btn-info text-white rounded-pill w-100 login-button"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
              {loading && (
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              )}

              {isSubmitted && errorMessage && (
                <label className="mb-2" style={{ color: "red" }}>
                  Error: {errorMessage}
                </label>
              )}

              {/* Back to Login */}
              <p className="text-center mt-3">
                <Link
                  to={from === "login" ? "/login" : "/signup"}
                  className="text-info fw-bold text-decoration-none"
                >
                  Back to {from === "login" ? "login" : "signup"}
                </Link>
              </p>
            </form>
          </main>
        </div>
      </div>
    </section>
  );
};

export default OtpValidation;
